import React, { Component } from 'react';
import PropTypes from 'prop-types';

import formatPhone from '../../helpers/format-phone';
import moment from 'moment';

import InputMask from 'react-input-mask';

class Input extends Component {
  static propTypes = {
    accent: PropTypes.bool,
    center: PropTypes.bool,
    date: PropTypes.bool,
    disable: PropTypes.bool,
    password: PropTypes.bool,
    required: PropTypes.bool,
    error: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    phone: PropTypes.bool,
    placeholder: PropTypes.string,
    textarea: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    indie: PropTypes.bool,
    lang: PropTypes.string,
    errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  };

  static defaultProps = {
    accent: false,
    center: false,
    date: false,
    disable: false,
    password: false,
    required: false,
    error: false,
    phone: false,
    placeholder: '',
    textarea: false,
    value: '',
    indie: false,
    lang: null,
    errorText: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };
  }

  componentDidMount() {
    if (this.props.textarea) autosize($(this.inp));
  }

  componentWillReceiveProps(nextProps) {
    const { indie } = this.props;

    if (!indie && this.state.value != nextProps.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  getMask = () => {
    let mask = '';
    const { date, phone } = this.props;

    if (phone) {
      mask = '+7 (999) 999-99-99';
    } else if (date) {
      mask = '99.99.9999';
    }

    return mask;
  };

  getInput() {
    const {
      date,
      disable,
      required,
      name,
      phone,
      placeholder,
      textarea,
      lang,
      password,
      onFocus,
    } = this.props;
    const { value } = this.state;
    const isEmailField = name === 'email';

    if (disable) {
      let val = value;

      if (phone) val = formatPhone(val);

      return <p className="inp__field">{`${val}\u00A0`}</p>;
    } else if (password) {
      return (
        <input
          className="inp__field"
          type="password"
          name={name}
          value={value}
          minLength="6"
          onChange={this.onChange}
          onFocus={() => {
            onFocus ? onFocus() : false;
          }}
          placeholder={placeholder}
          required={required ? true : false}
        />
      );
    } else if (date || phone) {
      return (
        <InputMask
          className="inp__field"
          placeholder={placeholder}
          name={name}
          mask={this.getMask()}
          onChange={this.onChange}
          onFocus={() => {
            onFocus ? onFocus() : false;
          }}
          type="text"
          value={value}
          required={required ? true : false}
        />
      );
    } else if (textarea) {
      return (
        <textarea
          className="inp__field"
          name={name}
          rows="1"
          value={value}
          onChange={this.onChange}
          placeholder={placeholder}
          ref={node => (this.inp = node)}
          required={required ? true : false}
        />
      );
    } else if (lang === 'rus') {
      return (
        <input
          className="inp__field"
          type="text"
          name={name}
          value={value}
          onChange={this.onChange}
          placeholder={placeholder}
          pattern="[А-Яа-яЁё]{1,}"
          title="Используйте только русские буквы"
          required={required ? true : false}
        />
      );
    } else {
      return (
        <input
          className="inp__field"
          type={isEmailField ? 'email' : 'text'}
          name={name}
          value={value}
          onChange={this.onChange}
          placeholder={placeholder}
          inputMode={isEmailField ? 'email' : undefined}
          autoCapitalize={isEmailField ? 'none' : undefined}
          autoCorrect={isEmailField ? 'off' : undefined}
          spellCheck={isEmailField ? false : undefined}
          onFocus={() => {
            onFocus ? onFocus() : false;
          }}
          required={required ? true : false}
        />
      );
    }
  }

  sanitizeEmailValue = value => {
    if (typeof value !== 'string') return '';

    // Remove spaces and disallow characters like ~ ! ; / etc.
    let next = value.replace(/\s+/g, '').replace(/[^A-Za-z0-9@._+-]/g, '');

    // Allow only one '@' (keep the first, drop the rest)
    const [local = '', ...rest] = next.split('@');
    if (rest.length === 0) return local;
    const domain = rest.join(''); // drops additional @ naturally
    return `${local}@${domain}`;
  };

  onChange = e => {
    const { onChange, name } = this.props;
    const rawValue = e.target.value;
    const nextValue = name === 'email' ? this.sanitizeEmailValue(rawValue) : rawValue;

    this.setState({
      value: nextValue,
    });

    if (onChange) onChange(nextValue, name);
  };

  render() {
    const { accent, center, error, label, textarea, errorText } = this.props;
    let classes = ['inp'];

    if (accent) classes.push('inp--accent');
    if (center) classes.push('inp--center');
    if (error) classes.push('inp--error');
    if (textarea) classes.push('inp--textarea');

    return (
      <div className={classes.join(' ')}>
        {this.getInput()}
        {label ? <div className="inp__label">{label}</div> : null}
        {error && errorText ? (
          <p className="inp__note inp__note--error">{errorText}</p>
        ) : null}
      </div>
    );
  }
}

export default Input;
